import moment from "moment";

// Perú (Lima) no tiene horario de verano, así que un offset fijo de UTC-5
// siempre es correcto. Usamos esto (y no moment() a secas) para calcular
// "hoy" en cualquier filtro de reportes por defecto: moment() toma la hora
// local del dispositivo/navegador, que puede estar en otra zona horaria
// (ej. una Mac configurada en hora de EE.UU.) — eso hacía que "hoy" quedara
// desfasado un día respecto a Lima durante varias horas de cada noche,
// y pedidos ya hechos "hoy" en Perú quedaban fuera del rango por defecto.
const LIMA_UTC_OFFSET_MINUTES = -5 * 60;

export function getLimaMoment() {
  return moment().utcOffset(LIMA_UTC_OFFSET_MINUTES);
}

export function getLimaToday() {
  return getLimaMoment().format("YYYY-MM-DD");
}

// Día operativo: el día de trabajo del local termina a las 5:00 AM, no a
// medianoche — una venta de la 1:30 AM del sábado es de la noche del viernes.
// Mismo valor en el backend (icard/business_day.py), que filtra los rangos
// date_from/date_to con este mismo corte.
export const BUSINESS_DAY_CUTOFF_HOUR = 5;

export function getBusinessMoment() {
  return getLimaMoment().subtract(BUSINESS_DAY_CUTOFF_HOUR, "hours");
}

// "Hoy" para los filtros de reportes: a la 1 AM sigue siendo el día anterior.
export function getBusinessToday() {
  return getBusinessMoment().format("YYYY-MM-DD");
}

export function getBusinessDaysAgo(days) {
  return getBusinessMoment().subtract(days, "days").format("YYYY-MM-DD");
}

// Día operativo de un pedido/pago (su timestamp ya trae el offset de Lima:
// parseZone lo respeta sin pasarlo a la hora del navegador).
export function getBusinessDate(timestamp) {
  return moment.parseZone(timestamp).subtract(BUSINESS_DAY_CUTOFF_HOUR, "hours");
}

// "hace unos segundos" (< 1 min), "hace 5 min", "hace 1 h 5 min". Solo
// minutos, sin segundos (pedido del usuario, para la pantalla del comensal).
// Se calcula contra `now` para poder refrescarlo con useNow().
export function formatElapsed(timestamp, now = Date.now()) {
  // Si el reloj del celular está un poco atrasado, el pedido puede parecer
  // "del futuro": se trata como recién hecho.
  const minutes = Math.max(0, Math.floor((now - moment(timestamp).valueOf()) / 60000));
  if (minutes < 1) return "hace unos segundos";
  if (minutes < 60) return `hace ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `hace ${hours} h ${rest} min` : `hace ${hours} h`;
}
